import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import { apiJson } from "../../../utils/api";

const AdmissionProcesses = () => {
  const [sessions, setSessions] = useState([]);
  const [degrees, setDegrees] = useState([]);

  useEffect(() => {
    apiJson("/api/admin/master/academic-sessions").then(setSessions).catch(() => {});
    apiJson("/api/admin/master/degrees").then(setDegrees).catch(() => {});
  }, []);

  const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-IN") : "-");

  return (
    <DataTable
      title="Admission Processes"
      apiPath="/api/admin/master/admission-processes"
      columns={[
        { key: "id", label: "ID" },
        { label: "Session", render: (i) => i.academicSession?.name || "-" },
        { label: "Degree", render: (i) => i.degree?.name || "-" },
        { key: "degreeCycle", label: "Cycle" },
        { key: "roundNumber", label: "Round" },
        { label: "Spot?", render: (i) => (i.isSpotAdmission ? "Yes" : "No") },
        { label: "From", render: (i) => fmt(i.fromDate) },
        { label: "To", render: (i) => fmt(i.toDate) },
        { label: "Late Fee Window", render: (i) => (i.isLateFeeAllowed ? `${fmt(i.lateFeeFromDate)} → ${fmt(i.lateFeeToDate)}` : "No") },
        { label: "Active", render: (i) => (i.isActive ? "Yes" : "No") },
      ]}
      formFields={[
        { separator: "Academic Session" },
        {
          key: "academicSessionId",
          label: "Academic Session",
          type: "select",
          required: true,
          options: sessions.map((s) => ({ value: s.id, label: s.name })),
        },
        { separator: "Round Details" },
        {
          key: "degreeId",
          label: "Degree",
          type: "select",
          required: true,
          options: degrees.map((d) => ({ value: d.id, label: d.name })),
        },
        { key: "degreeCycle", label: "Degree Cycle (semester)", type: "number", required: true },
        { key: "roundNumber", label: "Round Number", type: "number", required: true },
        { key: "isSpotAdmission", label: "Spot Admission", type: "checkbox" },
        { key: "fromDate", label: "From Date", type: "date", required: true },
        { key: "toDate", label: "To Date", type: "date", required: true },
        { separator: "Late Fee Window" },
        { key: "isLateFeeAllowed", label: "Late Fee Allowed", type: "checkbox" },
        { key: "lateFeeFromDate", label: "Late Fee From Date", type: "date" },
        { key: "lateFeeToDate", label: "Late Fee To Date (hard cutoff)", type: "date" },
        { separator: "Status" },
        { key: "isActive", label: "Active", type: "checkbox" },
      ]}
    />
  );
};

export default AdmissionProcesses;
